import { React, useEffect } from "react";
import "./style.css";

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="relative w-full h-full py-[50px] privacy-policy">
      <div className="relative max-w-[1140px] mx-auto px-4">
        <h1 className="text-[30px] md:text-[45px] laptop:text-[56px] font-semibold leading-none laptop:leading-[56px] tracking-tighter laptop:-tracking-[1px] text-white">
          Privacy Policy Vanar DPoS
        </h1>
        <h2>Privacy Policy</h2>
        <div className="list">
          <p>
            This Privacy Policy (this “Policy”) describes how Vanar Chain and its affiliates (“Vanar Chain,” “us” or “we”) may collect, use, and disclose information in connection with your access and/or use of any Interface or Features. Your use of the Interfaces and Features is subject to this Policy as well as our Terms of Use and any documents and additional terms or policies that expressly incorporate the Terms of Use (collectively, the “Terms”). Please read this Policy and the Terms carefully to ensure you understand them. Capitalized terms not defined herein have the same meaning as in the Terms.
          </p>
          <p>
            This Policy does not apply to any products, services, websites, or content offered or provided by third parties, and Vanar Chain is not responsible for those third-party offerings; please review any separate privacy policies made available by those third parties.
          </p>
          <p>
            We may update this Policy from time to time. If we make any changes, we will update the Last Updated date above. We encourage you to periodically review the Policy for the latest information on our privacy practices.
          </p>
          <p>
            Any modifications to this Policy will be effective upon our posting of the updated Policy. Your continued use of the Interfaces or Features following the posting of any updated Policy indicates your acceptance of the updated Policy.
          </p>
        </div>
        <h2>1. Information We Collect</h2>
        <h3 className="mb-2 text-base">
          a. Information You Give Us
        </h3>
        <div className="list">
          <p>
            When you access the Site, we may collect the following information:
          </p>
          <p>When you opt in to various programs, sign up for marketing information, send support requests/provide feedback, or otherwise voluntarily interact with us or the Interfaces:</p>
          <ul>
            <li>Contact information, such as name, email address, profile picture, user name, or social media information. </li>
            <li>Your preferences for receiving marketing information and communications from us.</li>
            <li>Your public wallet address when you connect your wallet to access certain Features.</li>
          </ul>

        </div>
        <h3 className="mb-2 text-base">b. Information Collected Automatically   </h3>
        <div className="list">
          <p>
            We may automatically collect certain information when you access, use, or interact with any Interface or Features, such as:
          </p>
          <ul>
            <li>Device type, browser type and version.</li>
            <li>Operating system and version.</li>
            <li>IP address.</li>
            <li>Publicly available blockchain data.</li>
            <li>Analytics about aggregate numbers of users and usage types (e.g., number of page views, event counts, and aggregate acquisition metrics), and information such as how many users are using certain Features; and aggregate location data including countries and regions from which users access the Site or Features.</li>
          </ul>
          <p>For information about how we use tracking technologies, please see our Cookie Policy.</p>
        </div>
        <h3 className="mb-2 text-base">c. Information Collected from Third Parties </h3>
        <div className="list">
          <p>We may receive additional information about you from third parties we work with (including contractors, collaborators, service providers, and analytics providers). This information may be combined with other information you provide to us or that we automatically collect.</p>
        </div>

        <h2>2. How We Use Information</h2>
        <div className="list">
          <p>
            We may use information about you to:
          </p>
          <ul>
            <li>Provide, maintain, support, and improve the Interfaces and Features and respond to inquiries related to them.</li>
            <li>Comply with our legal and regulatory obligations, as necessary.</li>
            <li>Prevent, detect, and investigate fraudulent, abusive, or harmful activities.</li>
            <li>Allow you to personalize your experience with the Interfaces or Features.</li>
            <li>Facilitate events and provide information to you about events.</li>
            <li>Provide support for the Interfaces and Features, including resolving issues and responding to your questions and feedback.</li>
            <li>Comply with legal requests such as subpoenas or requests from government authorities.</li>
            <li>Analyze usage trends to permit access to the Interfaces or provide the Features.</li>
            <li>Enforce the Terms, this Policy, and/or other policies.</li>
            <li>Take actions you have asked us to and provided consent for us to take.</li>
          </ul>
          <p>You agree that we may use information that does not identify you (including information that has been aggregated or de-identified) for any purpose, except as prohibited by applicable law.</p>
        </div>
        <h2>3. How We Share Information</h2>
        <div className="list">
          <p>
            We may share information about you with third parties, such as service providers, professional advisors, affiliates, and others. We may share information with those who help us operate the Interfaces or Features, such as marketing, event hosting, analytics, email delivery, and database management service providers, and professional advisors. Any sharing of information will be in accordance with this Policy.
          </p>
          <p>
            We may share information with third parties during business transactions, including mergers, acquisitions, reorganizations, or sales or transfers of all or part of our organization or assets.
          </p>
          <p>
            We may share information about you when necessary to comply with law, enforce the Terms and other agreements with you, or protect the rights, property, or security of Vanar Chain, our agents and employees, or users. This may include sharing information with other organizations for fraud prevention and detection.
          </p>
          <p>You may permit us to share your information with other entities or individuals of your choosing, subject to the privacy policies of those entities or individuals.</p>
        </div>
        <h2>4. Location of Information</h2>
        <p className="mb-2">
          Please be aware that information collected through the Interfaces or Features may be transferred to, processed, stored, and used in the United Arab Emirates and other jurisdictions. Data protection laws in these jurisdictions may differ from those in your country. Your use of the Interfaces or Features constitutes your consent to the transfer, processing, usage, sharing, and storage of information as set out in this Policy.
        </p>
        <h2>5. Access, Deletion, and Choice</h2>
        <p>
          To update or delete information about you or your interactions with the Interfaces or Features, you may contact us for assistance at <a className="text-green underline hover:no-underline" href="mailto:privacy@vanarchain.com">privacy@vanarchain.com</a>.
        </p>
        <p>You may also choose not to provide certain information, but this may prevent you from using certain Interfaces or Features.</p>
        <ul>
          <li><strong>Communications:</strong> To opt out of communications from Vanar Chain, adjust your communication preferences or unsubscribe.</li>
          <li><strong>Browser and Devices:</strong>  Most browsers and devices allow you to manage cookies. Please see our Cookie Policy for details.
          </li>
        </ul>
        <p>For additional information related to certain jurisdictions, see Section 9 below.</p>
        <h2>6. Children’s Information</h2>
        <p>The Interfaces and Features are intended for users 18 years or older and are not directed at children. We do not knowingly collect personal information from children. If you believe such information has been collected, please email at <a className="text-green underline hover:no-underline" href="mailto:privacy@vanarchain.com">privacy@vanarchain.com</a>.</p>
        <h2>7. Retention of Information</h2>
        <p>We retain information as long as necessary to fulfill the purposes described in this Policy, unless longer retention is required or permitted by law for tax, accounting, fraud prevention, investigative, and dispute resolution purposes, or to establish or defend a claim. In some cases, we may anonymize personal information, allowing us to use it indefinitely without further notice.</p>
        <h2>8. Notices</h2>
        <p>If you have any questions about this Privacy Policy, please contact us at:</p>
        <p>VANRY TECHNOLOGY DMCC        </p>
        <p>License No: DMCC-903913</p>
        <p>Unit No: UT-12-CO-46 DMCC Business Centre Level No 12 Uptown Tower Dubai United Arab Emirates</p>
        <p>If you interact with the Interfaces or Features on behalf of your organization, your information may also be subject to your organization’s privacy practices.</p>
        <h2>9. Additional Information for Certain Jurisdictions</h2>
        <h3 className="mb-2 text-base">California </h3>
        <p>If you are a California resident, you have certain rights under the California Consumer Privacy Act of 2018 (“CCPA”). This includes the right to request information about the categories of personal information we may have collected, used, or shared over the past 12 months. We do not sell personal information of consumers. For more information on your rights or to exercise them, please contact us (see “Contact Us” section).
        </p>
        <h3 className="mb-2 text-base">European Economic Area, the United Kingdom, and Switzerland </h3>
        <p>If you are a data subject in the European Economic Area, the United Kingdom, or Switzerland, you have certain rights under the General Data Protection Regulation (“GDPR”).</p>
        <p>Vanar Chain is the controller of your personal information for GDPR purposes. Our address is:</p>
        <p>VANRY TECHNOLOGY DMCC</p>
        <p>License No: DMCC-903913</p>
        <p>Unit No: UT-12-CO-46 DMCC Business Centre Level No 12 Uptown Tower Dubai United Arab Emirates</p>
        <p>You may:</p>
        <ul>
          <li>Request copies of your personal data.</li>
          <li>Update or correct inaccuracies.</li>
          <li>Request deletion.</li>
          <li>Obtain a portable copy of your personal data.</li>
          <li>Restrict processing where applicable.</li>
          <li>Object to certain processing.</li>
        </ul>
        <p>These rights are subject to applicable law. If you have a complaint, you may also contact your local data protection authority.</p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
